"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[194],{

/***/ 13194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TutorProfileLocation; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/context.js

const CONTEXT_VERSION = 1;
function createLeafletContext(map) {
    return Object.freeze({
        __version: CONTEXT_VERSION,
        map
    });
}
function extendContext(source, extra) {
    return Object.freeze({
        ...source,
        ...extra
    });
}
const LeafletContext = (0,react.createContext)(null);
const LeafletProvider = LeafletContext.Provider;
function useLeafletContext() {
    const context = (0,react.useContext)(LeafletContext);
    if (context == null) {
        throw new Error('No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>');
    }
    return context;
}

// EXTERNAL MODULE: ./node_modules/leaflet/dist/leaflet-src.js
var leaflet_src = __webpack_require__(45243);
;// CONCATENATED MODULE: ./node_modules/react-leaflet/lib/MapContainer.js
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}



function MapContainerComponent({ bounds , boundsOptions , center , children , className , id , placeholder , style , whenReady , zoom , ...options }, forwardedRef) {
    const [props] = (0,react.useState)({
        className,
        id,
        style
    });
    const [context, setContext] = (0,react.useState)(null);
    (0,react.useImperativeHandle)(forwardedRef, ()=>context?.map ?? null
    , [
        context
    ]);
    const mapRef = (0,react.useCallback)((node)=>{
        if (node !== null && context === null) {
            const map = new leaflet_src.Map(node, options);
            if (center != null && zoom != null) {
                map.setView(center, zoom);
            } else if (bounds != null) {
                map.fitBounds(bounds, boundsOptions);
            }
            if (whenReady != null) {
                map.whenReady(whenReady);
            }
            setContext(createLeafletContext(map));
        }
    }, []);
    (0,react.useEffect)(()=>{
        return ()=>{
            context?.map.remove();
        };
    }, []);
    const contents = context ? /*#__PURE__*/ react.createElement(LeafletProvider, {
        value: context
    }, children) : placeholder ?? null;
    return /*#__PURE__*/ react.createElement("div", _extends({}, props, {
        ref: mapRef
    }), contents);
}
const MapContainer = /*#__PURE__*/ (0,react.forwardRef)(MapContainerComponent);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/component.js



function component_createContainerComponent(useElement) {
    function ContainerComponent(props, forwardedRef) {
        const { instance , context  } = useElement(props).current;
        (0,react.useImperativeHandle)(forwardedRef, ()=>instance
        );
        return props.children == null ? null : /*#__PURE__*/ react.createElement(LeafletProvider, {
            value: context
        }, props.children);
    }
    return /*#__PURE__*/ (0,react.forwardRef)(ContainerComponent);
}
function component_createDivOverlayComponent(useElement) {
    function OverlayComponent(props, forwardedRef) {
        const [isOpen, setOpen] = useState(false);
        const { instance  } = useElement(props, setOpen).current;
        useImperativeHandle(forwardedRef, ()=>instance
        );
        useEffect(function updateOverlay() {
            if (isOpen) {
                instance.update();
            }
        }, [
            instance,
            isOpen,
            props.children
        ]);
        // @ts-ignore _contentNode missing in type definition
        const contentNode = instance._contentNode;
        return contentNode ? /*#__PURE__*/ createPortal(props.children, contentNode) : null;
    }
    return /*#__PURE__*/ forwardRef(OverlayComponent);
}
function component_createLeafComponent(useElement) {
    function LeafComponent(props, forwardedRef) {
        const { instance  } = useElement(props).current;
        (0,react.useImperativeHandle)(forwardedRef, ()=>instance
        );
        return null;
    }
    return /*#__PURE__*/ (0,react.forwardRef)(LeafComponent);
}

;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/element.js

function element_createElementObject(instance, context, container) {
    return Object.freeze({
        instance,
        context,
        container
    });
}
function element_createElementHook(createElement, updateElement) {
    if (updateElement == null) {
        return function useImmutableLeafletElement(props, context) {
            return (0,react.useRef)(createElement(props, context));
        };
    }
    return function useMutableLeafletElement(props, context) {
        const elementRef = (0,react.useRef)(createElement(props, context));
        const propsRef = (0,react.useRef)(props);
        const { instance  } = elementRef.current;
        (0,react.useEffect)(function updateElementProps() {
            if (propsRef.current !== props) {
                updateElement(instance, props, propsRef.current);
                propsRef.current = props;
            }
        }, [
            instance,
            props,
            context
        ]);
        return elementRef;
    };
}

;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/attribution.js

function useAttribution(map, attribution) {
    const attributionRef = (0,react.useRef)(attribution);
    (0,react.useEffect)(function updateAttribution() {
        if (attribution !== attributionRef.current && map.attributionControl != null) {
            if (attributionRef.current != null) {
                map.attributionControl.removeAttribution(attributionRef.current);
            }
            if (attribution != null) {
                map.attributionControl.addAttribution(attribution);
            }
        }
        attributionRef.current = attribution;
    }, [
        map,
        attribution
    ]);
}

;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/events.js

function useEventHandlers(element, eventHandlers) {
    const eventHandlersRef = (0,react.useRef)();
    (0,react.useEffect)(function addEventHandlers() {
        if (eventHandlers != null) {
            element.instance.on(eventHandlers);
        }
        eventHandlersRef.current = eventHandlers;
        return function removeEventHandlers() {
            if (eventHandlersRef.current != null) {
                element.instance.off(eventHandlersRef.current);
            }
            eventHandlersRef.current = null;
        };
    }, [
        element,
        eventHandlers
    ]);
}

;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/pane.js
function withPane(props, context) {
    const pane = props.pane ?? context.pane;
    return pane ? {
        ...props,
        pane
    } : props;
}

;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/layer.js





function useLayerLifecycle(element, context) {
    (0,react.useEffect)(function addLayer() {
        const container = context.layerContainer ?? context.map;
        container.addLayer(element.instance);
        return function removeLayer() {
            context.layerContainer?.removeLayer(element.instance);
            context.map.removeLayer(element.instance);
        };
    }, [
        context,
        element
    ]);
}
function layer_createLayerHook(useElement) {
    return function useLayer(props) {
        const context = useLeafletContext();
        const elementRef = useElement(withPane(props, context), context);
        useAttribution(context.map, props.attribution);
        useEventHandlers(elementRef.current, props.eventHandlers);
        useLayerLifecycle(elementRef.current, context);
        return elementRef;
    };
}

;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/path.js





function usePathOptions(element, props) {
    const optionsRef = (0,react.useRef)();
    (0,react.useEffect)(function updatePathOptions() {
        if (props.pathOptions !== optionsRef.current) {
            const options = props.pathOptions ?? {};
            element.instance.setStyle(options);
            optionsRef.current = options;
        }
    }, [
        element,
        props
    ]);
}
function createPathHook(useElement) {
    return function usePath(props) {
        const context = useLeafletContext();
        const elementRef = useElement(withPane(props, context), context);
        useEventHandlers(elementRef.current, props.eventHandlers);
        useLayerLifecycle(elementRef.current, context);
        usePathOptions(elementRef.current, props);
        return elementRef;
    };
}

;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/generic.js






function createControlComponent(createInstance) {
    function createElement(props, context) {
        return createElementObject(createInstance(props), context);
    }
    const useElement = createElementHook(createElement);
    const useControl = createControlHook(useElement);
    return createLeafComponent(useControl);
}
function createLayerComponent(createElement, updateElement) {
    const useElement = createElementHook(createElement, updateElement);
    const useLayer = createLayerHook(useElement);
    return createContainerComponent(useLayer);
}
function createOverlayComponent(createElement, useLifecycle) {
    const useElement = createElementHook(createElement);
    const useOverlay = createDivOverlayHook(useElement, useLifecycle);
    return createDivOverlayComponent(useOverlay);
}
function createPathComponent(createElement, updateElement) {
    const useElement = element_createElementHook(createElement, updateElement);
    const usePath = createPathHook(useElement);
    return component_createContainerComponent(usePath);
}
function createTileLayerComponent(createElement, updateElement) {
    const useElement = element_createElementHook(createElement, updateElement);
    const useLayer = layer_createLayerHook(useElement);
    return component_createLeafComponent(useLayer);
}

;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/grid-layer.js
function updateGridLayer(layer, props, prevProps) {
    const { opacity , zIndex  } = props;
    if (opacity != null && opacity !== prevProps.opacity) {
        layer.setOpacity(opacity);
    }
    if (zIndex != null && zIndex !== prevProps.zIndex) {
        layer.setZIndex(zIndex);
    }
}

;// CONCATENATED MODULE: ./node_modules/react-leaflet/lib/TileLayer.js


const TileLayer = createTileLayerComponent(function createTileLayer({ url , ...options }, context) {
    const layer = new leaflet_src.TileLayer(url, withPane(options, context));
    return element_createElementObject(layer, context);
}, updateGridLayer);

;// CONCATENATED MODULE: ./node_modules/@react-leaflet/core/lib/circle.js
function updateCircle(layer, props, prevProps) {
    if (props.center !== prevProps.center) {
        layer.setLatLng(props.center);
    }
    if (props.radius != null && props.radius !== prevProps.radius) {
        layer.setRadius(props.radius);
    }
}

;// CONCATENATED MODULE: ./node_modules/react-leaflet/lib/Circle.js


const Circle = createPathComponent(function createCircle({ center , children: _c , ...options }, ctx) {
    const circle = new leaflet_src.Circle(center, options);
    return element_createElementObject(circle, extendContext(ctx, {
        overlayContainer: circle
    }));
}, updateCircle);

;// CONCATENATED MODULE: ./components/tutorProfile/Location.js


function TutorProfileLocation(param) {
    let { tutorProfile  } = param;
    const style = {
        width: "100%",
        height: "200px"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MapContainer, {
            center: [
                tutorProfile.lat,
                tutorProfile.lon
            ],
            zoom: 10,
            style: style,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TileLayer, {
                    url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle, {
                    center: [
                        tutorProfile.lat,
                        tutorProfile.lon
                    ],
                    radius: 2000
                })
            ]
        })
    });
}


/***/ })

}]);